import React from 'react';
import { useTranslation } from 'react-i18next';
import type { SingleValue } from 'react-select';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Filter } from '@/js/libs/ui/src/V2';

import type { Option } from 'src/types';
import { useCampaignTypesOptions } from '../hooks/useCampaignTypesOptions';

interface CampaignTypeFilterProps {
  value: Option<string> | null;
  onChange: (value: SingleValue<Option<string>>) => void;
  label?: string;
}

export const CampaignTypeFilter: React.FC<CampaignTypeFilterProps> = React.memo(function CampaignTypeFilter({ value, onChange, label }) {
  const [t] = useTranslation(['backend', 'common', 'modules']);
  const { options, pending: loading } = useCampaignTypesOptions();

  const handleChange = useCallbackRef((newValue: SingleValue<Option<string>>) => {
    onChange(newValue);
  });

  return (
    <Filter<string>
      label={label || t('common:CAMPAIGN_TYPE')}
      loading={loading}
      selected={value}
      onChange={handleChange}
      options={options}
      dataTestId='campaign-type-dropdown'
    />
  );
});
